import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from './Useletter';
import Foter from './Foter';
import './Catu.css';

function Catu() {
  return (
    <div>
      <Container>

        
<Row>
  
    <Col  xs={12} sm={6} md={4}> <div className="box-cont">
    <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/24-Qaboolhai/12_cover.jpg"
   alt=''style={{height:'400px', width:'100%',
   
   }} /></div> <b>Apparel</b>
   </div>
   </Col>
        <Col  xs={12} sm={6} md={4}> <div className="box-cont">
    <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/24-TeensBoysWinter/12_cover.jpg"
   alt=''style={{height:'400px', width:'100%',
   
   }} /></div><b>Apparel</b>
   
  
</div></Col>
<Col  xs={12} sm={6} md={4}>
        <div className="box-cont">
        <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/24-winternewdrop/12_cover.jpg"
           alt=''style={{height:'400px', width:'100%' }} /> </div>
  <b>Apparel</b>
   </div>
   
        </Col>

      </Row>
    </Container>

    <Container>

        
<Row>
  
    <Col  xs={12} sm={6} md={4}> <div className="box-cont">
    <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/cover_-_Copy_-_Copy_-_Copy_1.jpg"
   alt=''style={{height:'400px', width:'100%',
   
   }} /></div> <b>Apparel</b>
   </div>
   </Col>
        <Col  xs={12} sm={6} md={4}> <div className="box-cont">
    <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/TEEN_BOYS_COVER.jpg"
   alt=''style={{height:'400px', width:'100%',
   
   }} /></div><b>Apparel</b>
   
  
</div></Col>
<Col  xs={12} sm={6} md={4}>
        <div className="box-cont">
        <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/COVER1.jpg"
           alt=''style={{height:'400px', width:'100%' }} /> </div>
  <b>Apparel</b>
   </div>
   
        </Col>

      </Row>
    </Container>



    <Container>

        
<Row>
  
    <Col  xs={12} sm={6} md={4}> <div className="box-cont">
    <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/cover_60.jpg"
   alt=''style={{height:'400px', width:'100%',
   
   }} /></div> <b>Apparel</b>
   </div>
   </Col>
        <Col  xs={12} sm={6} md={4}> <div className="box-cont">
    <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/TS.jpg"
   alt=''style={{height:'400px', width:'100%',
   
   }} /></div><b>Apparel</b>
   
  
</div></Col>
<Col  xs={12} sm={6} md={4}>
        <div className="box-cont">
        <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/cover_-_Copy_-_Copy_-_Copy.jpg"
           alt=''style={{height:'400px', width:'100%' }} /> </div>
  <b>Apparel</b>
   </div>
   
        </Col>

      </Row>
    </Container>




    <Container>

        
<Row>
  
    <Col  xs={12} sm={6} md={4}> <div className="box-cont">
    <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/24-covers/cover.jpg"
   alt=''style={{height:'400px', width:'100%',
   
   }} /></div> <b>Apparel</b>
   </div>
   </Col>
        <Col  xs={12} sm={6} md={4}> <div className="box-cont">
    <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/24-covers/cover_-_Copy_-_Copy.jpg"
   alt=''style={{height:'400px', width:'100%',
   
   }} /></div><b>Apparel</b>
   
  
</div></Col>
<Col  xs={12} sm={6} md={4}>
        <div className="box-cont">
        <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/24-covers/cover_-_Copy_-_Copy_-_Copy.jpg"
           alt=''style={{height:'400px', width:'100%' }} /> </div>
  <b>Apparel</b>
   </div>
   
        </Col>

      </Row>
    </Container>




    <Container>

        
<Row>
  
    <Col  xs={12} sm={6} md={4}> <div className="box-cont">
    <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/24-covers/cover_-_Copy.jpg"
   alt=''style={{height:'400px', width:'100%',
   
   }} /></div> <b>Apparel</b>
   </div>
   </Col>
        <Col  xs={12} sm={6} md={4}> <div className="box-cont">
    <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/cover_59.jpg"
   alt=''style={{height:'400px', width:'100%',
   
   }} /></div><b>Apparel</b>
   
  
</div></Col>
<Col  xs={12} sm={6} md={4}>
        <div className="box-cont">
        <div className="img-bo"><img src="https://www.junaidjamshed.com/media/wysiwyg/cover_57.jpg"
           alt=''style={{height:'400px', width:'100%' }} /> </div>
  <b>Apparel</b>
   </div>
   
        </Col>

      </Row>
    </Container>
<Useletter/>
<Foter/>



    </div>
  )
}

export default Catu
